import type { FeedItem } from '../api/types'

/**
 * Which rows the activity card shows, and in which order.
 *
 * The card is read top-down as "what just happened", and the live half already
 * behaves that way: a frame arriving on the stream is put at the front. The
 * historical half arrives from `/engage/feed` in the log's own order, which is
 * oldest-first, because that is what a handheld replaying from a saved
 * position needs and the endpoint answers both callers with one shape.
 *
 * Concatenating the two and cutting at the limit therefore kept the *oldest*
 * rows of the page the server sent. #101 fixed which page that is — a first
 * read asks for the newest events rather than for the log's beginning — and
 * this is the other half of the same defect, in the client: with the newest
 * two hundred events in hand, the card still showed the thirty oldest of them,
 * so on a project with real history it lagged by the rest of the page and the
 * thing that happened a minute ago was never on it.
 *
 * The log's order is not changed here, only the reading of it. A caller that
 * wants the log ascending still gets it ascending from the API; the card is a
 * screen, and a screen is allowed to have an opinion about which end matters.
 */
export function feedRows(
  streamed: readonly FeedItem[],
  historical: readonly FeedItem[],
  limit = 30,
): FeedItem[] {
  return [...streamed, ...[...historical].reverse()].slice(0, limit)
}
